// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagOutlinedSvg from "@ant-design/icons-svg/es/asn/TagOutlined";
import AntdIcon from '../components/AntdIcon';

var TagOutlined = function TagOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagOutlinedSvg
  }));
};

TagOutlined.displayName = 'TagOutlined';
export default React.forwardRef(TagOutlined);